export default {
    name : 'wcReviewTable',

    init()
    {
        const el = document.getElementById('wcReviewTable');
        if (el) {
            this.run();
        }
    },

    run (vueData)
    {
        // const vueData = [vueData]
        window['wcReviewTable'] = new Vue({
            el: '#wcReviewTable',

            delimiters: ['@{','}'],

            data : {
                'busy'          : "",
                'coupons'       : [],
                'isReady'       : "",
                'shippingName'  : "",
                'totalItems'    : 0,
                'totalItemsTax' : 0,
                'subTotal'      : 0,
                'totalPrice'    : 0,
                'cartTotal'     : 0,
                'shippingTotal' : 0,
                'shippingTax'   : 0,
                'totalTax'      : 0,
                'freeShipping'  : 500
            },

            filters: {
                nok (value)
                {
                    value = parseInt(value);

                    if (!Number.isInteger(value)) {
                        return null;
                    }

                    // value = (value >0) ? value/100 : value;
                    value = value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
                    // return value + this.currency;
                    return value + ',-';
                }
            },

            computed :
            {

            },

            methods:
            {
                isFreeShipping()
                {
                    return (this.totalItems >= this.freeShipping);
                },

                getCart()
                {
                    this.toggleBusy();
                    wcRest.getCart(this.updateReview);
                    this.initEditCartItems();
                },

                toggleBusy()
                {
                    this.busy = (this.busy==='busy') ? '' : 'busy';
                },

                updateReview(response)
                {
                    if (typeof response === 'object' && typeof response.data === 'object') {
                        const json = response.data;

                        this.totalItems     = parseInt(json.totals.total_items);
                        this.totalItemsTax  = parseInt(json.totals.total_items_tax);
                        this.totalPrice     = parseInt(json.totals.total_price);
                        this.shippingTotal  = parseInt(json.totals.total_shipping);
                        this.totalTax       = parseInt(json.totals.total_tax);
                        this.shippingTax    = parseInt(json.totals.total_shipping_tax);
                        this.coupons       = (typeof json.coupons === 'object') ? json.coupons : [];

                        if (this.isB2B() && typeof json.shipping_rates === 'object' && typeof json.shipping_rates[0] === 'object') {
                            const shippingRates = json.shipping_rates[0];
                            for (let i=0; i<shippingRates.shipping_rates.length; i++) {
                                if (shippingRates.shipping_rates[i].selected===true) {
                                    this.shippingName = '/'+shippingRates.shipping_rates[i].name;
                                    break;
                                }
                            }
                        }
                    }
                    this.toggleBusy();
                },

                initEditCartItems()
                {
                    // _log('init cart items');
                    const elements = document.querySelectorAll('.cartEditItemQty');
                    // _log(elements.length);

                    if (typeof elements === 'object' && elements.length) {
                        elements.forEach((el) => {
                                el.addEventListener('click', this.updateQty);
                            }
                        );
                    }
                },

                updateQty( event )
                {
                    let button = null;

                    if (typeof event.target.dataset.rel !== 'undefined') {
                        button = event.target;
                     } else {
                        button = event.target.parentNode;
                     }

                    if (button) {
                        const cartItem = button.closest('.productQty');
                        const carTitemQty = cartItem.querySelector('.qty');
                        if (carTitemQty) {
                            let qty = parseInt(carTitemQty.value);

                            if (button.dataset.function==='increase') {
                                qty +=1;
                            } if (button.dataset.function==='decrease') {
                                qty -=1;
                            }

                            qty = (qty > 999) ? 999 : qty;
                            qty = (qty < 0) ? 0 : qty;
                            carTitemQty.value = qty;

                            document.querySelector("button[name='update_cart']").disabled = false;
                        }
                    }
                },

                isB2B()
                {
                    const el = document.getElementById('b2b');

                    return (el);
                }

            },

            created ()
            {
                // _log("review table ready");
                this.isReady = ' isReady ';
                document.getElementById('wcReviewTable').classList.remove('d-none');
                this.getCart();
            }
      }); // close vue app

    }, // close run
} // close class